module.exports = __webpack_public_path__ + "images/tour/lesson_plan_by_day_remove_children-6600c2c3f4a4ccbf27a3ff91e37f2270.gif";